/** Constantes do MobileBarNavigation — para ancorar elementos flutuantes sem alterar o menu. */
export const MOBILE_NAV_BOTTOM = 4;
export const MOBILE_NAV_MAX_WIDTH = 420;
export const MOBILE_NAV_HORIZONTAL_INSET = 16;
/** Altura aproximada da pill (ícone + label + padding). */
export const MOBILE_NAV_APPROX_HEIGHT = 52;
const MOBILE_NAV_ICON_SIZE = 40;
/** Eleva o ícone flutuante acima do centro da pill. */
const MOBILE_LUXOR_FLOAT_LIFT = 24;
/** Desloca o ícone um pouco para a esquerda em relação à borda direita. */
export const MOBILE_LUXOR_FLOAT_SHIFT_LEFT = 10;

/** Borda direita da pill (mesma geometria do menu centralizado). */
export const mobileNavRightEdgeCss = `calc(50% - min(${MOBILE_NAV_MAX_WIDTH / 2}px, calc((100vw - ${MOBILE_NAV_HORIZONTAL_INSET * 2}px) / 2)))`;

/** Posição horizontal do ícone flutuante (borda direita + leve deslocamento à esquerda). */
export const mobileNavFloatTriggerRightCss = `calc(50% - min(${MOBILE_NAV_MAX_WIDTH / 2}px, calc((100vw - ${MOBILE_NAV_HORIZONTAL_INSET * 2}px) / 2)) + ${MOBILE_LUXOR_FLOAT_SHIFT_LEFT}px)`;

/** Base do ícone flutuante — levemente acima do centro vertical da pill. */
export const mobileNavFloatTriggerBottomCss = `calc(${MOBILE_NAV_BOTTOM}px + env(safe-area-inset-bottom, 0px) + ${MOBILE_NAV_APPROX_HEIGHT / 2 - MOBILE_NAV_ICON_SIZE / 2 + MOBILE_LUXOR_FLOAT_LIFT}px)`;
